export default {
  'InputWithButton.Wrapper.Input': ({ value }, outlet) => {
    outlet({ value, action: 'change' })
  },
  'InputWithButton.Wrapper.Input(Keydown)': ({ value, key, disabled }, outlet) => {
    if (key === 'Enter' && !disabled) {
      outlet({ value, action: 'click' })
    }
  },
  'InputWithButton.Button': ({ value, disabled }, outlet) => {
    if (!disabled) {
      outlet({ value, action: 'click' })
    }
  }
}